import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function getLast24HoursRange(now: Date = new Date()) {
  const to = dayjs.utc(now);

  return {
    from: to.subtract(24, "hour").toDate(),
    to: to.toDate(),
  };
}
